.wrapper {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid var(--box-border-color, #e0e0e0);
  font-size: 11px;
  line-height: 1.4;
}

.title {
  font-size: 18px;
  font-weight: 700;
  color: var(--main-text, #1a1a1a);
  margin: 0 0 2px;
}

.subtitle {
  font-size: 11px;
  color: var(--body-text, #666);
  margin-bottom: 6px;
}

.legend {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

.legendSection {
  display: flex;
  align-items: center;
  gap: 12px;
}

.legendItem {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: var(--body-text, #555);
}

.legendDot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.legendBar {
  width: 24px;
  height: 8px;
  border-radius: 1px;
}

.legendSeparator {
  width: 1px;
  height: 14px;
  background: var(--box-border-color, #ccc);
  margin: 0 4px;
}

/* Category colors */
.catElection {
  background: #8b3a3a;
}
.catEconomic {
  background: #8b7d3a;
}
.catClimate {
  background: #4a7a4a;
}
.catIndustry {
  background: #3a6b7a;
}
.catSummit {
  background: #c17a3a;
}

/* Status modifiers */
.barExpected {
  opacity: 0.55;
}
.barTbc {
  background: transparent !important;
  border: 1.5px dashed;
}
.barTbc.catElection {
  border-color: #8b3a3a;
}
.barTbc.catEconomic {
  border-color: #8b7d3a;
}
.barTbc.catClimate {
  border-color: #4a7a4a;
}
.barTbc.catIndustry {
  border-color: #3a6b7a;
}
.barTbc.catSummit {
  border-color: #c17a3a;
}

/* Chart */
.chartContainer {
  position: relative;
  width: 100%;
  overflow-x: auto;
}

.monthHeaders {
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-left: 320px;
  position: sticky;
  top: 0;
  background: var(--main-background, #fff);
  z-index: 10;
}

.monthHeader {
  flex: 1;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  color: var(--body-text, #666);
  padding: 4px 0;
  border-left: 1px solid #eee;
}

/* Rows */
.eventRow {
  display: flex;
  align-items: center;
  min-height: 22px;
  border-bottom: 1px solid var(--box-border-color, #f5f5f5);
}

.eventRow:hover {
  background: rgba(0, 0, 0, 0.02);
}

.eventLabel {
  width: 320px;
  min-width: 320px;
  padding-right: 12px;
  font-size: 10.5px;
  color: var(--main-text, #444);
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.eventTimeline {
  flex: 1;
  position: relative;
  height: 22px;
}

.gridLines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  pointer-events: none;
}

.gridLine {
  flex: 1;
  border-left: 1px solid rgba(0, 0, 0, 0.04);
}

.eventBar {
  position: absolute;
  height: 8px;
  top: 7px;
  border-radius: 1px;
  min-width: 3px;
}

.eventLocation {
  position: absolute;
  top: 3px;
  font-size: 9px;
  color: var(--body-text, #888);
  white-space: nowrap;
}
